import PageLayout from '@rentivo/gatsby-theme-barcelona/src/components/layouts/PageLayout/component';

export default PageLayout;
